import { t } from 'i18next';
import { useMemo } from 'react';

import { ButtonProps } from '@components/Button';
import Modal, { ActionBlock, IconBlock, MessageBlock, Title } from '@components/Modal';

interface NetworkStatusModalProps {
  isOnline: boolean;
  close: () => void;
}

const NetworkStatusModal = ({ isOnline, close }: NetworkStatusModalProps) => {
  const actionButtons = useMemo(() => {
    const closeAction: ButtonProps = {
      appearance: 'primary',
      onClick: close,
      text: t('common:ok'),
    };

    return [closeAction];
  }, [close]);

  return (
    <Modal testId="network-status-popup" minWidth="47.5rem">
      <IconBlock icon={isOnline ? 'wifiIcon' : 'warning'} size={80} />
      <Title
        title={isOnline ? t('common:networkOnline.title') : t('common:networkOffline.title')}
        titleAlignment="center"
        titleWeight="bolder"
        fontSize="medium"
        titleColor="darkGray"
      />
      <MessageBlock
        messages={isOnline ? t('common:networkOnline.message') : t('common:networkOffline.message')}
      />
      {isOnline && <ActionBlock actions={actionButtons} />}
    </Modal>
  );
};

export default NetworkStatusModal;
